import lodashGet from 'lodash/get';
import { api } from '@/api/api';
import { apis } from '@/config';
class IMDiscussApiImpl {
    constructor() {
        this.name = apis.imDiscussApiImpl;
        this.httpApi = api.getDataTransApi();
        this.systemApi = api.getSystemApi();
        this.mailApi = api.requireLogicalApi(apis.mailApiImpl);
    }
    init() {
        return this.name;
    }
    getUrl(url) {
        return this.systemApi.getUrl(url);
    }
    parseResult(res) {
        return res.data;
    }
    catchError(reason) {
        return reason;
    }
    createDiscuss(option) {
        return this.httpApi
            .post(this.getUrl('createDiscuss'), option, {
            contentType: 'json',
        })
            .then(res => {
            if (lodashGet(res, 'data.code', 999) !== 0) {
                throw new Error(lodashGet(res, 'data.message', '创建失败'));
            }
            return res.data;
        });
    }
    getDiscussMail(option) {
        return this.httpApi.get(this.getUrl('getDiscussMail'), option).then(this.parseResult).catch(this.catchError);
    }
    getDiscussMailDetail(option) {
        return this.httpApi.post(this.getUrl('getDiscussMailDetail'), option).then(this.parseResult).catch(this.catchError);
    }
    getMailDiscuss(option) {
        return this.httpApi.get(this.getUrl('getMailDiscuss'), option, { contentType: 'json' }).then(this.parseResult).catch(this.catchError);
    }
    cancelDiscussBind(option) {
        return this.httpApi
            .post(this.getUrl('cancelDiscussBind'), option, {
            contentType: 'json',
        })
            .then(this.parseResult)
            .catch(this.catchError);
    }
    discussMailAttach(option) {
        return this.httpApi.post(this.getUrl('discussMailAttach'), option).then(this.parseResult).catch(this.catchError);
    }
    shareMail(option) {
        return this.httpApi.post(this.getUrl('shareMail'), option, { contentType: 'json' }).then(this.parseResult).catch(this.catchError);
    }
}
const imDiscussApiImpl = new IMDiscussApiImpl();
api.registerLogicalApi(imDiscussApiImpl);
export default imDiscussApiImpl;
